import { useState } from 'react';
import {
  Card,
  PregnancyCard,
  PregnancyTitle,
  TrimesterImage,
  ViewMore,
} from './styled';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { getSearchParams } from '../../Parenting/common';
import { getContentType, removeDefaultParams } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { images } from '../../../Constants/ImageUrls';
import { fireClickedCTAEvent } from '../../../Utils/useFirebase';

export default function PregnancyCards(props) {
  const { categoryRedirect, cardData, sectionName } = props;

  let router = useRouter();
  const [gridCardSignal, setGridCardSignal] = useState({
    index: '',
    show: false,
  });
  let router_param = { ...router.query };
  // router_param.stage = "pregnancy";

  return (
    <Card>
      {cardData?.map((data, index0) => {
        return (
          <PregnancyCard key={index0}>
            <Link
              href={{
                pathname: data?.web_url,
                query: removeDefaultParams(router_param),
              }}
              passHref
              locale={false}
              onClick={(e) => {
                e.preventDefault();
                setTimeout(() => {
                  router.push(data?.web_url + getSearchParams(), '', {
                    locale: getRouterLocale(router),
                  });
                }, [200]);
                setGridCardSignal({
                  index: `${index0}`,
                  show: true,
                });
                categoryRedirect(
                  data?.term_id,
                  data?.description,
                  data?.description,
                  data?.web_url,
                );
              }}
            >
              <div
                className={
                  gridCardSignal.index === `${index0}`
                    ? 'gridcardopacity transitionClass trimImageSec'
                    : 'transitionClass trimImageSec'
                }
              >
                <TrimesterImage
                  src={`${data?.image}?tr=w-400,q-90`}
                  srcSet={`${data?.image}?tr=w-420,q-90 2w, ${data?.image}?tr=w-430,q-90 720w`}
                  sizes="(max-width: 720px) 2px,720px"
                  loading="lazy"
                />
                <PregnancyTitle>{data?.description}</PregnancyTitle>
              </div>
            </Link>
            <ul>
              {data?.items.map((subData, index) => {
                return (
                  <Link
                    href={{
                      pathname: subData?.web_url || subData?.content?.web_url,

                      query: removeDefaultParams(router_param),
                    }}
                    passHref
                    key={index + '_subdata'}
                    locale={false}
                    onClick={(e) => {
                      e.preventDefault();
                      setTimeout(() => {
                        router.push(
                          subData?.web_url ||
                            subData?.content?.web_url + getSearchParams(),
                          '',
                          {
                            locale: getRouterLocale(router),
                          },
                        );
                      }, [200]);
                      setGridCardSignal({
                        index: `${index}_${index0}`,
                        show: true,
                      });
                    }}
                    className={
                      gridCardSignal.index === `${index}_${index0}`
                        ? 'gridcardopacity transitionClass'
                        : 'transitionClass'
                    }
                  >
                    <li>
                      <p
                        key={index + subData?.term_id || subData?.tagId}
                        onClick={() =>
                          categoryRedirect(
                            subData?.term_id || subData?.tagId,
                            data?.description,
                            subData?.description || subData?.content?.title,
                            subData?.web_url || subData?.content?.web_url,
                          )
                        }
                      >
                        {subData?.description || subData?.content?.title}
                      </p>
                      <img src={images.arrowforward} loading="lazy" alt="" />
                    </li>
                  </Link>
                );
              })}
            </ul>
            {data?.web_url ? (
              <Link
                href={{
                  pathname: data?.web_url,
                }}
                passHref
                locale={false}
                legacyBehavior
              >
                <ViewMore
                  onClick={() =>
                    fireClickedCTAEvent(
                      sectionName ? sectionName : data?.description,
                      'View More',
                      getContentType(),
                    )
                  }
                  as="a"
                >
                  View More
                </ViewMore>
              </Link>
            ) : null}
          </PregnancyCard>
        );
      })}
    </Card>
  );
}
